import React from 'react'
import Popover from '@mui/material/Popover';
import MoreVertIcon from '../../../components/MoreVertIcon';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Axios from 'axios';
import { Box } from "@mui/material";
import { getAuthHeader } from '../../../utils/authToken';
import MemoEditModal from './MemoEditModal';

const MemoVertIcon = ({
    memo,
    student_uuid,
    setStudentUpdated,
    setSuccessAlertOpen,
    setSuccessAlertMessage,
    setErrorAlertOpen,
    setErrorAlertMessage,
    socket,
    socketConnected,
    from_weekly,
    getStudentName = null,
}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleMoreVertIconClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopOverClose = () => {
        setAnchorEl(null);
    };

    const popoverOpen = Boolean(anchorEl);
    const popoverId = popoverOpen ? 'popover' : undefined;

    // for edit modal
    const [editModalOpen, setEditModalOpen] = React.useState(false);
    const handleEditModalOpen = () => setEditModalOpen(true);
    const handleEditModalClose = () => { setEditModalOpen(false); setAnchorEl(null); };

    // The editor itself is MemoEditModal (shared with the Missed Calls page); this decides what a save means here.
    const handleMemoSaved = (response) => {
        if (from_weekly && socketConnected) {
            socket.emit("put.StudentUpdate", {
                student_uuid: student_uuid,
                message: getStudentName !== null ? " edited one of the memos of " + getStudentName() : " edited one of the memos of a student",
            });
        } else {
            setStudentUpdated(true);
            setSuccessAlertOpen(true);
            setSuccessAlertMessage(response.data.message);
        }
    };

    const handleMemoEditError = (error) => {
        console.log(error);
        setErrorAlertOpen(true);
        setErrorAlertMessage(error.response?.data?.message || "Something went wrong");
    };

    // for delete dialog
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const handleClickDialogOpen = () => {
        setDialogOpen(true);
    };
    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const deleteMemo = async (e, memo_id) => {
        e.preventDefault();

        await Axios.delete(`${process.env.REACT_APP_URL}/api/v1/students/${student_uuid}/memos/${memo_id}`, {
            headers: {
                Authorization: getAuthHeader(),
            },
        }).then((response) => {
            if (from_weekly && socketConnected) {
                socket.emit("put.StudentUpdate", {
                    student_uuid: student_uuid,
                    message: getStudentName !== null ? " deleted one of the memos of " + getStudentName() : " deleted one of the memos of a student",
                });
            } else {
                setStudentUpdated(true);
                setSuccessAlertOpen(true);
                setSuccessAlertMessage(response.data.message);
            }
            handleDialogClose();
        }).catch((error) => {
            setErrorAlertOpen(true);
            setErrorAlertMessage(error.response?.data?.message || "Something went wrong");
        });
    }

    return (
        <><MoreVertIcon handleClick={handleMoreVertIconClick} iconColor={'primary'} />
        <Popover
            id={popoverId}
            open={popoverOpen}
            anchorEl={anchorEl}
            onClose={handlePopOverClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                {/* EDIT */}
                <Button
                    variant="text"
                    color="primary"
                    onClick={handleEditModalOpen}
                >
                    Edit
                </Button>
                <MemoEditModal
                    open={editModalOpen}
                    onClose={handleEditModalClose}
                    memo={memo}
                    studentUuid={student_uuid}
                    onSaved={handleMemoSaved}
                    onError={handleMemoEditError}
                />

                {/* DELETE */}
                <Button
                    variant="text"
                    color="error"
                    onClick={handleClickDialogOpen}
                >
                    Delete
                </Button>
                <Dialog
                    open={dialogOpen}
                    onClose={handleDialogClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                    {"Are you sure you want to delete this memo?"}
                    </DialogTitle>
                    <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        This action cannot be undone.
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={handleDialogClose}>Cancel</Button>
                    <Button onClick={(e) => deleteMemo(e, memo.id)} color="error" autoFocus>
                        Delete
                    </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </Popover></>
    )
}

export default MemoVertIcon
